import React from 'react';
import { Check, Hourglass, Star } from 'lucide-react';
import { formatMoney } from '../../utils/formatMoney';

function cellClass(state, isSelected) {
  if (state === 'won') {
    return 'border-green-400 bg-green-50 text-green-800';
  }
  if (state === 'lost') {
    return 'border-gray-300 bg-gray-100 text-gray-600';
  }
  if (state === 'pending') {
    return 'border-amber-300 bg-amber-50 text-amber-700';
  }
  if (isSelected) {
    return 'border-brand-red bg-brand-gold-light text-brand-red shadow-sm';
  }
  return 'border-gray-200 bg-white text-brand-red hover:border-brand-gold';
}

export function SoiDaoBoard({ cells = [], selected = [], onToggle }) {
  const selectedSet = new Set(selected);

  return (
    <div className="w-full overflow-hidden">
      <div className="grid w-full grid-cols-10 gap-0.5 sm:gap-1.5">
        {cells.map((cell) => {
          const isSelected = selectedSet.has(cell.position);
          const isAvailable = cell.state === 'available';
          const disabled = !isAvailable;

          return (
            <button
              key={cell.position}
              type="button"
              disabled={disabled}
              onClick={() => isAvailable && onToggle?.(cell.position)}
              className={`relative flex aspect-square min-w-0 flex-col items-center justify-center rounded border p-0 text-[8px] transition-all sm:rounded-lg sm:border-2 sm:p-0.5 sm:text-xs ${cellClass(
                cell.state,
                isSelected,
              )} ${disabled ? 'cursor-default' : 'cursor-pointer'}`}
              aria-label={`ตำแหน่ง ${cell.position}`}
            >
              {cell.state === 'available' ? (
                <>
                  <Star
                    className={`h-3 w-3 sm:h-4 sm:w-4 ${
                      isSelected
                        ? 'fill-brand-gold text-brand-gold'
                        : 'fill-brand-gold/80 text-brand-gold'
                    }`}
                  />
                  <span className="mt-0.5 font-mono font-semibold leading-none">
                    {cell.position}
                  </span>
                  {isSelected ? (
                    <span className="absolute inset-0 flex items-center justify-center rounded-[inherit] bg-brand-red/15">
                      <Check className="h-4 w-4 text-brand-red sm:h-5 sm:w-5" />
                    </span>
                  ) : null}
                </>
              ) : null}

              {cell.state === 'pending' ? (
                <>
                  <Hourglass className="h-3 w-3 animate-pulse sm:h-4 sm:w-4" />
                  <span className="mt-0.5 font-mono font-semibold leading-none">
                    {cell.position}
                  </span>
                </>
              ) : null}

              {(cell.state === 'won' || cell.state === 'lost') && (
                <>
                  <span className="font-mono text-[11px] font-bold leading-none sm:text-base">
                    {cell.result}
                  </span>
                  {cell.state === 'won' && cell.payout > 0 ? (
                    <span className="mt-0.5 hidden text-[9px] font-semibold leading-none text-green-700 min-[380px]:block sm:text-[10px]">
                      {formatMoney(cell.payout)}
                    </span>
                  ) : (
                    <span className="mt-0.5 hidden text-[9px] leading-none text-gray-400 min-[380px]:block sm:text-[10px]">
                      {cell.position}
                    </span>
                  )}
                </>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
